<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="guestMoves" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="guestMoveId"
  selectionMode="single" [(selection)]="guestMove" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="showPaginator" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="fs-5" [class.small-text]="reservationId">Guest Move</div>
      </div>
      <div>
        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
          }

          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem;"
          (click)="onOpenFormAdd()" [class.small-btn]="reservationId">New Guest Move +</button>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [ngStyle]="{'width': 'auto'}">
          @if (col.sorting) {
            <span [pSortableColumn]="col.field">
              {{ col.header }}
              @if (!reservationId) {
                <p-sortIcon [field]="col.field"></p-sortIcon>
              }
            </span>
          } @else {
            {{ col.header }}
          }
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (!reservationId) {
      <tr >
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestMoveId', 'in')"></th> -->
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'orderId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
        (input)="pt.filter($event.target.value, 'srcMoveDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'scrPropertyCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
        (input)="pt.filter($event.target.value, 'destMoveDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'destPropertyCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'moveReason', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-guestMove>
    <tr [pSelectableRow]="guestMove">
      <!-- <td>{{guestMove.guestMoveId}} </td> -->
      <td>{{guestMove.orderId}}</td>
      <td>{{guestMove?.srcMoveDate ? (guestMove.srcMoveDate | date:'MM/dd/yyyy hh:mm a') : '-'}}</td>
      <td>{{guestMove.scrPropertyCode}}</td>
      <td>{{guestMove?.destMoveDate ? (guestMove.destMoveDate | date:'MM/dd/yyyy hh:mm a') : '-'}}</td>
      <td>{{guestMove.destPropertyCode}}</td>
      <td>{{guestMove?.moveReason ? guestMove.moveReason : '-'}}</td>
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(guestMove)">edit</mat-icon>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>